import React from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

import { isDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import styles from '../styles/productCell';
import flowRight from 'lodash.flowright';
import withSettings from '../../../utils/withSettings';
import { connect } from 'react-redux';
import { translate } from '../../../i18n/I18nProvider';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { formatDateForSchedule } from '../../../utils/formatDate';
import ExclamationTriangleIcon from '../../../partials/customIcons/ExclamationTriangleIcon';

const ProductCell = ({ rowData, lang, classes, products = [] }) => {
  const product = Optional(rowData.translations?.sku?.[lang]).or(
    rowData.translations?.sku?.default
  );

  const isTerminationPending = rowData.status === 'TERMINATION_PENDING';
  const isOutported = rowData.status === 'OUTPORTED';
  const showTerminationIcon = isTerminationPending || isOutported;
  const hasMigration = isDefined(rowData.migration);

  return (
    <div className={classes.root}>
      {product}
      {showTerminationIcon && (
        <Tooltip
          title={
            <div>
              <div>
                {isOutported
                  ? translate('SUBSCRIPTIONS.OUTPORTING_IN_PROGRESS')
                  : translate('SUBSCRIPTIONS.TERMINATION_IN_PROGRESS')}
              </div>
              <div>
                {isOutported
                  ? `${translate(
                      'SUBSCRIPTIONS.OUTPORTING_DATE'
                    )}: ${formatDateForSchedule(rowData.expiryDate)}`
                  : `${translate(
                      'SUBSCRIPTIONS.TERMINATION_DATE'
                    )}: ${formatDateForSchedule(rowData.expiryDate)}`}
              </div>
            </div>
          }
        >
          <ExclamationTriangleIcon />
        </Tooltip>
      )}
      {!showTerminationIcon && hasMigration && (
        <Tooltip
          title={
            <div>
              <div>{`${capitaliseFirstLetter(
                translate('SUBSCRIPTIONS.CURRENTLY_IN_MIGRATION')
              )} ${findTranslation({ products, lang, rowData })}`}</div>
              <div>{`${translate('SUBSCRIPTIONS.CHANGE_DATE')} : ${
                rowData.migration.changeDate
              }`}</div>
            </div>
          }
        >
          <ExclamationTriangleIcon />
        </Tooltip>
      )}
    </div>
  );
};

const mapStatesToProps = ({ iotProducts, auth }) => {
  return {
    products: iotProducts.products,
    lang: auth.lang
  };
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps),
  withStyles(styles)
)(ProductCell);

const findTranslation = ({ products, lang, rowData }) => {
  const product = products.find(
    product => product.sku === rowData.migration?.sku
  );

  if (!product) {
    return rowData.migration?.sku;
  }

  return Optional(product.translations?.sku?.[lang]).or(
    Optional(product.translations?.sku?.default).or(rowData.migration?.sku)
  );
};
